import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';
import { ArrowLeft, CreditCard } from 'lucide-react';

export default function PaymentMethods() {
  const { orgId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(`/enterprise/orgs/${orgId}/billing`)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        <div>
          <h1 className="font-heading text-2xl font-bold text-gray-900">Payment Methods</h1>
          <p className="text-gray-600 mt-1">Manage your payment methods</p>
        </div>
      </div>

      <Card className="p-12 rounded-lg text-center">
        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
          <CreditCard className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="font-heading text-lg font-semibold text-gray-900 mb-2">
          No payment methods
        </h3>
        <p className="text-gray-600 mb-6">
          Add a credit card to enable paid features
        </p>
        <Button variant="outline">
          Add Payment Method
        </Button>
        <p className="text-xs text-gray-500 mt-4">Stripe integration ready (mocked)</p>
      </Card>
    </div>
  );
}
